import Immutable from "immutable";
import * as Sentry from "@sentry/browser";

import ActionTypes from "../ActionTypes";
import createReducer from "../../util/createReducer";
import { version } from "../../../package.json";

const { NODE_ENV } = process.env;
const defaultAuthState = {
  authenticated: false,
  token: "",
  id: "",
  username: "",
  firstName: "",
  lastName: "",
  isStaff: "",
  isSuperuser: "",
  groups: []
};

const initialState = Immutable.fromJS({
  ...defaultAuthState,
  version: NODE_ENV === "development" ? "LOCALDEV" : version
});

export default createReducer(initialState, {
  [ActionTypes.Auth.setAuthData](state, { obj }) {
    const { id, firstName, lastName } = obj;
    Sentry.configureScope(scope => {
      scope.setUser({ id, firstName, lastName });
    });
    return state.merge(obj);
  },
  [ActionTypes.Auth.logout](state) {
    localStorage.removeItem("PPJWT");
    Sentry.configureScope(scope => {
      scope.setUser();
    });
    return state.merge(defaultAuthState);
  },
  [ActionTypes.Auth.login](state) {
    return state;
  }
});



// WEBPACK FOOTER //
// /src/store/reducers/Auth.js